/**
 * Page-level texts (titles, subtitles, table headers) grouped by app section.
 * Each file owns a unique top-level key.
 */

import taxCorePages from "./taxCorePages.js";
import taxReturnsPages from "./taxReturnsPages.js";
import eprPages from "./eprPages.js";
import invoicePages from "./invoicePages.js";
import authorizePages from "./authorizePages.js";
import corePages from "./corePages.js";
import accountPages from "./accountPages.js";
import sharedUi from "./sharedUi.js";

export default {
  ...taxCorePages,
  ...taxReturnsPages,
  ...eprPages,
  ...invoicePages,
  ...authorizePages,
  ...corePages,
  ...accountPages,
  ...sharedUi,
};
